<template>
  <div class="shell">
    <router-view />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "Shell",
  data() {
    return {
      websock: null,
      heartCheck: null,
      closeFlag: true
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  created() {
    console.log(process.env);

    if (this.userInfo.eduName) {
      document.title = `${this.userInfo.eduName} - ${this.userInfo.pageTitle || ''}`
    }
  },
  mounted() {
    this.initWebSocket(); // 初始化websocket
    this.heartCheckFun();
    this.$bus.$on("wantGetWebsocketObject", this.getWebsocket); // 监听websocket，等组件想要获取websocket的时候传递给该组件
  },
  beforeDestroy() {
    this.closeFlag = false;
    if (this.websock) {
      this.websock.close();
    }
  },
  methods: {
    initWebSocket: function() {
      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
      if (!this.userInfo) return;
      var userId = this.userInfo.id;
      var url = `${process.env.websocketURL}${userId}`;
      this.websock = new WebSocket(url);
      this.websock.onopen = this.websocketOnopen;
      this.websock.onerror = this.websocketOnerror;
      this.websock.onmessage = this.websocketOnmessage;
      this.websock.onclose = this.websocketOnclose;
    },
    websocketOnopen() {
      this.heartCheck.reset().start();
    },
    websocketOnerror(e) {
      if (this.closeFlag) {
        this.reconnect();
      } else {
      }
    },
    websocketOnmessage(e) {
      // console.log(e.data)
      var data = eval("(" + e.data + ")"); // 解析对象
      if (data.cmd === "response") {
        // 提示
        this.$message.info(data.hint);
      } else if (data.cmd === "addTask") {
        this.$emit("addTask", data.msgTxt);
      } else if (data.cmd === "overTask") {
        this.$emit("overTask", data.msgTxt);
      } else if (data.cmd === "view") {
        this.$bus.$emit("getStatus", data);
      } else if (data.cmd === "sign") {
        this.$bus.$emit("getSign", data);
      } else if (data.cmd === "pay") {
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        userInfo.feeFlag = data.feeFlag;
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
      } else if (data.cmd === "chitchat") {
        let timer = setTimeout(() => {
          this.$message.info("您收到一条新消息，请到论文指导与审批页面查看！");
        }, 300);

        this.$bus.$emit("newMessageWillbeReceive", data, res => {
          if (res.status) {
            clearTimeout(timer);
          }
        });
      }
    },
    websocketOnclose(e) {
      this.heartCheck.reset();
      if (this.closeFlag) {
        this.reconnect();
      } else {
      }
    },
    ...mapMutations(["changeUserInfo"]),
    websocketSend(text) {
      // 数据发送
      try {
        this.websock.send(text);
      } catch (err) {}
    },
    reconnect() {
      var that = this;
      if (that.lockReconnect) return;
      that.lockReconnect = true;
      // 没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function() {
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    heartCheckFun() {
      var that = this;
      // 心跳检测,每5m心跳一次
      that.heartCheck = {
        timeout: 300000,
        timeoutObj: null,
        serverTimeoutObj: null,
        reset: function() {
          if (this.timeoutObj == null) {
            clearTimeout(this.timeoutObj);
            this.timeoutObj = null;
          }
          return this;
        },
        start: function() {
          this.timeoutObj = setTimeout(function() {
            // onmessage拿到返回的心跳就说明连接正常
            that.websocketSend(`{"cmd":"HeartBeat"}`);
          }, this.timeout);
        }
      };
    },
    getWebsocket() {
      if (this.websock) {
        this.$bus.$emit("getWebsocketObject", this.websock);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/shell/shell.vue